import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import { LOAI_PHONG, TERM_CLASS_IDS } from '../../../../utils/Constant';
import EditableCell from './EditableCell';
import useDepartmentOptions from './hooks/useDepartmentOptions';

const Select = ({ setEnableEditing, updateRowData, row }: any) => {
	const rowData = row.original;

	const SERVICE_DEPARTMENT_TYPE_MAPPING = {
		[TERM_CLASS_IDS.XET_NGHIEM]: LOAI_PHONG.PHONG_XET_NGHIEM,
		[TERM_CLASS_IDS.CDHA]: LOAI_PHONG.PHONG_CDHA,
		[TERM_CLASS_IDS.PTTT]: LOAI_PHONG.PTTT,
	};

	const fulfillDepartmentDefault = rowData?.attributes?.deptLaboratoryCode
		? [
				{
					name: rowData?.attributes?.deptLaboratoryName,
					value: rowData?.attributes?.deptLaboratoryCode,
				},
		  ]
		: [];
		
	const fulfillDepartmentConfigByTerm = rowData?.attributes?.deptLaboratories
		? JSON.parse(rowData?.attributes?.deptLaboratories).map((item: any) => ({
				name: item?.name,
				value: item?.code,
		  }))
		: [];

	const currentValue = rowData?.fulfillDeptCode
		? [
				{
					name: rowData?.fulfillDeptName,
					value: rowData?.fulfillDeptCode,
				},
		  ]
		: [];

	const { departmentOptions } = useDepartmentOptions({
		defaultOptions: [
			...currentValue,
			...fulfillDepartmentDefault,
			...fulfillDepartmentConfigByTerm,
		],
		configType: SERVICE_DEPARTMENT_TYPE_MAPPING[rowData?.classId]
	});

	return (
		<AutocompleteV2
			autoFocus
			options={departmentOptions}
			value={currentValue}
			name="fulfillDepartment"
			onChange={(selectedOption: any) => {
				updateRowData(row.index, "fulfillDepartment", selectedOption);
				setEnableEditing(false);
			}}
			onBlur={() => {
				setEnableEditing(false);
			}}
		/>
	);
};

const FulFillDepartmentCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;
	const textValue = rowData?.fulfillDeptName;

	return (
		<EditableCell
			editComponent={(props: any) => (
				<Select row={row} updateRowData={updateRowData} {...props} />
			)}
			textValue={textValue}
			className="spaces h-30 line-height-30"
		/>
	);
};

export default FulFillDepartmentCell;
